<div class="buttonbar-view">
  <a uiSref="a.material.inventory.create" title="Artikel Einpflegen" class="btn btn-default">
    <span class="fa fa-plus"></span>
  </a>
  @if (('material.planning.manual.start'|HasPerm)) {
    <material-planning-force-check-button (reloaded)="search()"
      >
    </material-planning-force-check-button>
  }
</div>

<form [formGroup]="form">
  <div class="row" [formGroup]="form">
    <div [ngClass]="{'col-lg-12': !selectedWeek, 'col-lg-10': !!selectedWeek}">
      <h3>Material Planung</h3>
      <div class="filter-row">
        <div class="filter-left">
          <material-product-groups-tab-list [productGroups]="productGroups.objects"
            [groups]="groups.objects"
            [activeGroupIds]="[currentGroupId]"
            [singleMode]="true"
            (setGroupId)="selectGroup($event)">
          </material-product-groups-tab-list>
        </div>

        <div class="filter-right">
          <button class="btn btn-sm btn-warning" type="button" (click)="toggleOn('cfa', true)">
            <i class="fa" [ngClass]="{'fa-toggle-on': form.value.cfa, 'fa-toggle-off': !form.value.cfa}">
            </i>
            &nbsp;Zu wenig Material
          </button>

          <button class="btn btn-sm btn-danger" type="button" (click)="toggleOn('cfa_by_date', true)">
            <i class="fa" [ngClass]="{'fa-toggle-on': form.value.cfa_by_date, 'fa-toggle-off': !form.value.cfa_by_date}">
            </i>
            &nbsp;Termin nicht möglich
          </button>
        </div>
      </div>

      @if (fields.data$|async; as fieldList) {
        <table class="table whitetable">
          <thead>
            <tr>
              <th [colSpan]="4 + fieldList.length + numInventoryCols * 2 + numPlanningCols" rowspan="3">
                <div class="row">
                  <div class="col-sm-4"></div>
                  <div class="col-sm-8">
                    <span [ngClass]="{label: hasSelectedDate, 'label-success': hasSelectedDate}">
                      Bestellungen und BAs berücksichtigen:
                    </span>
                    @if (hasSelectedDate) {
                      <button type="button"
                        class="btn btn-default btn-sm"
                        (click)="unsetDateLimit()"
                        >
                        <i class="fa fa-trash-o"></i>
                      </button>
                    }
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <customer-box buttonLabel="Kunde auswählen"
                      [customer]="customer"
                      [disabledHeader]="true"
                      (updateEmitter)="selectCustomer($event)">
                    </customer-box>
                  </div>
                  <div class="col-sm-1">
                    <label for="date-limit-from" class="control-label">Von:</label>
                  </div>
                  <div class="col-sm-3">
                    <ev-datepicker-react id="date-limit-from"
                                         formControlName="date_limit_from"
                                         [future]="true"
                                         [inputClassName]="clsx(
                                         'leading-bs-form-control-sm!',
                                          'text-bs-form-control-sm!',
                                          'pt-[10px]',
                                          'pr-[5px]',
                                          'pb-[10px]',
                                          'pl-[5px]',
                                          'h-[30px]',
                                          { 'red_alert': !!filterFormErrors.date_limit_from}
                                         )">
                    </ev-datepicker-react>
                  </div>
                  <div class="col-sm-1">
                    <label for="date-limit-to" class="control-label">Bis:</label>
                  </div>
                  <div class="col-sm-3">
                    <ev-datepicker-react id="date-limit-to"
                                         formControlName="date_limit_to"
                                         [future]="true"
                                         [inputClassName]="clsx(
                                         'leading-bs-form-control-sm!',
                                          'text-bs-form-control-sm!',
                                          'pt-[10px]',
                                          'pr-[5px]',
                                          'pb-[10px]',
                                          'pl-[5px]',
                                          'h-[30px]',
                                          { 'red_alert': !!filterFormErrors.date_limit_to}
                                         )">
                    </ev-datepicker-react>
                  </div>
                </div>
              </th>
              <th class="align-right" rowspan="3">
                <i class="fa fa-arrow-circle-left fa-2x ev-blue-color"
                  ngbTooltip="Woche früher"
                  (click)="weekScrollPage(-1)">
                </i>
              </th>
              @for (index of weekPaginator.visibleWeekIndices; track index) {
                <th colspan="2"><strong>KW</strong></th>
              }
              <th rowspan="3">
                <i class="fa fa-arrow-circle-right fa-2x ev-blue-color"
                  ngbTooltip="Woche später"
                  (click)="weekScrollPage(1)">
                </i>
              </th>
            </tr>
            <tr>
              @for (index of weekPaginator.visibleWeekIndices; track index) {
                <th colspan="2">
                  <strong [ngbTooltip]="'Ab ' + (list.weeks[index].first_day_of_week|date:'dd.MM.yyyy')">
                    {{list.weeks[index].week}}/{{list.weeks[index].first_day_of_week|date:'yy'}}
                  </strong>
                </th>
              }
            </tr>
            <tr>
              @for (index of weekPaginator.visibleWeekIndices; track index) {
                <th colspan="2"
                  style="font-size: 10px;"
                  >
                  {{list.weeks[index].first_day_of_week|date:'dd.MM.yyyy'}}
                </th>
              }
            </tr>
            <tr>
              <th class="w-75">
                <a class="click" (click)="sort('supplier')">
                  Lieferant
                </a>
              </th>
              <th>
                <a class="click" (click)="sort('article_name')">
                  Bezeichnung
                </a>
              </th>
              <th class="align-right">
                <a class="click" (click)="sort('vendor_price')">
                  Preis
                </a>
              </th>
              @for (field of fieldList; track field) {
                <th>
                  <a class="click" (click)="sort(field.html_name)">
                    {{field.name}}
                  </a>
                </th>
              }
              <th class="align-right" title="Lagerbestand">Bestand</th>
              <th [ngClass]="{'align-right': numInventoryCols < 2}" [colSpan]="numInventoryCols">Bestellt</th>
              <th [ngClass]="{'align-right': numInventoryCols < 2}" [colSpan]="numInventoryCols">Bestätigt</th>
              <th class="align-right"><span ngbTooltip="Überfällig">Überf.</span></th>
              <th [ngClass]="{'align-right': numPlanningCols < 2}" [colSpan]="numPlanningCols">Planung</th>
              @for (index of weekPaginator.visibleWeekIndices; track index) {
                <th class="align-right">
                  <i class="fa fa-truck"
                    [ngbTooltip]="'bestätigte Lieferungen in KW ' + list.weeks[index].week">
                  </i>
                </th>
                <th class="align-right">
                  <i class="fa fa-handshake-o"
                    [ngbTooltip]="'geplante Materialnutzung in KW ' + list.weeks[index].week">
                  </i>
                </th>
              }
              <th></th>
            </tr>
            <tr class="filterrow">
              <th>
                <select class="form-control input-sm"
                  name="supplier_id"
                  formControlName="supplier_id"
                  [ngClass]="{ 'red_alert': !!filterFormErrors.supplier_id }">
                  <option [ngValue]="null">-</option>
                  @for (supplier of suppliers; track supplier) {
                    <option [ngValue]="supplier.id">
                      {{supplier.name}}
                    </option>
                  }
                </select>
              </th>
              <th>
                @if (articleNames.data$ | async; as articles) {
                  <select class="form-control input-sm"
                    name="article_name"
                    formControlName="article_name"
                    [ngClass]="{ 'red_alert': !!filterFormErrors.article_name }">
                    <option [ngValue]="null">-</option>
                    @for (article of articles; track article) {
                      <option [ngValue]="article">{{article}}</option>
                    }
                  </select>
                } @else {
                  <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
                }
                <loading-or-error #loadingOrError
                  [loadingWrapper]="articleNames"
                  [errorMessage]="'Konnte Artikelnamen nicht laden'">
                </loading-or-error>
              </th>
              <th></th>
              @for (field of fieldList; track field) {
                <th>
                  @switch (field.data_type) {
                    @case ('Auswahl') {
                      <select class="form-control input-sm"
                        [name]="field.html_name"
                        [ngClass]="{ 'red_alert': !!filterFormErrors[field.html_name] }"
                        [formControlName]="field.html_name">
                        <option [ngValue]="null" selected>-</option>
                        @for (choice of field.choices; track choice) {
                          <option [ngValue]="choice">{{choice}}</option>
                        }
                      </select>
                    }
                    @case ('Option') {
                      @switch (this.form[field.html_name]) {
                        @case (true) {
                          <i class="fa fa-check click" (click)="triStateChange(field)"></i>
                        }
                        @case ('true') {
                          <i class="fa fa-check click" (click)="triStateChange(field)"></i>
                        }
                        @case (false) {
                          <i class="fa fa-times click" (click)="triStateChange(field)"></i>
                        }
                        @case ('false') {
                          <i class="fa fa-times click" (click)="triStateChange(field)"></i>
                        }
                        @default {
                          <i class="fa fa-check click gray_font" (click)="triStateChange(field)"></i>
                        }
                      }
                    }
                    @default {
                      <input class="form-control input-sm"
                        [name]="field.html_name"
                        [ngClass]="{ 'red_alert': !!filterFormErrors[field.html_name] }"
                        [formControlName]="field.html_name">
                    }
                  }
                </th>
              }
              <th [colSpan]="3 + numInventoryCols * 2 + numPlanningCols + weekPaginator.visibleWeekIndices.length * 2"></th>
            </tr>
          </thead>
          <tbody>
            @for (material of list.objects; track material) {
              <tr [material-planning-row]="material"
                [material-planning-row-week-pages]="weekPaginator.visibleWeekIndices"
                [material-planning-row-selected-week]="selectedWeek"
                [material-planning-row-selected-variation-id]="selectedVariationId"
                [material-planning-row-start-date]="startDate"
                [material-planning-row-customer]="customer"
                [material-planning-row-fields]="fieldList"
                (material-planning-row-select-week)="setSelectedWeek($event, material.inventory.id)"
                >
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
      }
      @if (list && list.count === 0) {
        <div>
          Keine Material Artikel mit diesen Kriterien Gefunden
        </div>
      }
      <ev-navigation [page]="list.page" [pages]="list.pages" [query]="form.value" (goto)="goto($event)"></ev-navigation>

      <loading-or-error #loadingOrError
        [loadingWrapper]="fields"
        [errorMessage]="'Konnte Material Felder für Gruppe nicht laden'"
        [spinnerSize]="2"
        spinnerName="circle-o-notch">
      </loading-or-error>
    </div>
    @if (selectedWeek && selectedVariationId) {
      <div class="col-lg-2">
        <material-planning-sidebar [inventory]="selectedVariation"
          [week]="selectedWeek"
          (closeEvent)="setSelectedWeek(null, null)">
        </material-planning-sidebar>
      </div>
    }
  </div>
</form>
